import {
	ProductKeys3P,
	type ProductKeys3P as ProductKeys3PType,
} from '@atlassian/rovo-connectors-config/types';

/**
 * Fallback order when smartlink usage data isn't available. Only includes
 * products that are commonly connected across workspaces.
 */
export const STATIC_FALLBACK_ORDER: readonly ProductKeys3PType[] = [
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Slack,
	ProductKeys3P.Github,
	ProductKeys3P.Figma,
];
